import { Component, OnInit, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { AddEditUserService } from '../../../../../../services/add-edit-user.service';

@Component({
    selector: 'user-account-search',
    templateUrl: './user-account-search.component.html',
    styleUrls: ['./user-account-search.component.scss']
})
export class UserAccountSearchComponent implements OnInit {
    isOpen: boolean;
    searchTerm: string;
    showDdl: boolean;
    @Input() tempContent: any = [];
    @Input() searchKey1: string;
    @Input() searchKey2: string;
    @Output() account = new EventEmitter();
    arrowkeyLocation: any;

    constructor(private manageUser: AddEditUserService) {
        this.arrowkeyLocation = 0;
    }

    @HostListener('window:keyup.enter')
    changeByEnterkey() {
        var _list = this.tempContent as any[];
        var list = _list[this.arrowkeyLocation];
        this.change(list);
    }

    search(e) {
        if (e.target) {
            if (this.searchTerm != "" && this.searchTerm != undefined && this.searchTerm.length > 2) {
                this.manageUser.getAccounts(this.searchTerm, (res) => {
                    this.tempContent = res;
                    for (var i = 0; i < this.tempContent.length; i++) {
                        this.tempContent[i].IsDefault = false;
                    }
                    setTimeout((x) => {
                        this.tempContent = res;
                        this.showDdl = true;
                    }, 500)
                },
                    (err) => {
                    }
                )
            }
            else {
                this.tempContent = [];
                this.showDdl = false;
            }
        }
        else {
            this.tempContent = this.tempContent.filter(item => {
                if (item.key != undefined) {
                    return item.key.toLowerCase().startsWith(e.toLowerCase());
                }
            })
        }
    }

    change(item) {
        this.account.emit(item);
        this.searchTerm = "";
        this.showDdl = false;
    }

    @HostListener('window:keydown', ['$event'])
    onarrowDown(event) {
        if (event.key == 'ArrowDown') {
            if (this.arrowkeyLocation < this.tempContent.length - 1)
                return this.arrowkeyLocation++;
        }
        else {
            if (event.key == 'ArrowUp') {
                if (this.arrowkeyLocation > 0)
                    return this.arrowkeyLocation--;
            }
        }
    }

    ngOnInit() {
        this.searchTerm = "";
    }

}
